export default __webpack_public_path__ + "static/orderByTypeDescLocation-1d645227cfda8d3662b9c72b3c6a936a.png";